module.exports = __webpack_public_path__ + "assets/img/type_1.bc5ba4eb.png";